export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || 'https://dev-elisa.staging.forasoft.com';

const SOCKET_EVENTS_VERSION = 'v1';

const SOCKET_EVENTS_STREAMING = `${SOCKET_EVENTS_VERSION}:streaming`;
export const STREAM_ENDED = `${SOCKET_EVENTS_STREAMING}:ended`;

const SOCKET_EVENTS_STAGE = `${SOCKET_EVENTS_VERSION}:stage`;
export const STAGE_PLAYER_ENDED = `${SOCKET_EVENTS_STAGE}:playerEnded`;
export const STAGE_PUBLISHER_STARTED = `${SOCKET_EVENTS_STAGE}:publisherStarted`;
export const STAGE_PUBLISHER_STOPPED = `${SOCKET_EVENTS_STAGE}:publisherStopped`;
export const STAGE_RELOAD = `${SOCKET_EVENTS_STAGE}:reload`;
export const STAGE_RELOAD_OVERLAY = `${SOCKET_EVENTS_STAGE}:reloadOverlay`;
export const STAGE_PLAY_VIDEO = `${SOCKET_EVENTS_STAGE}:playVideo`;
export const STAGE_SET_MULTI_STAGE_OPTIONS = `${SOCKET_EVENTS_STAGE}:setMultiStageOptions`;
export const STAGE_MULTI_DEVICE_READY = `${SOCKET_EVENTS_STAGE}:multiDeviceStageReady`;
export const STAGE_MULTI_STAGE_DEVICES_IN_VIEW = `${SOCKET_EVENTS_STAGE}:multiStageDevicesInView`;
